export default {
  namespaced: true,
  actions: {
    subscribeToVendor: function ({ dispatch }, payload) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post(`user/subscribe`, payload)
          .then(() => {
            return resolve(true);
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  (err.data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve();
          });
      });
    },
    unsubscribeToVendor: function ({ dispatch }, payload = {}) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .delete(`user/unsubscribe/${payload.id}`)
          .then(() => {
            return resolve(true);
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  (err.data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve();
          });
      });
    },
  },
};
